module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1521-c4017e268818d462c3d0ea6e4eac9765.png";